import React, { Component } from 'react'
import { withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import { Tabs, Typography, Spin, Row, Col, Input, message, Table, Icon, Button, Popconfirm, Form, Select, Radio, DatePicker, Avatar, Modal, InputNumber } from 'antd'
import { checkDisbledInput, setSummaryTotal, checkStatus } from '../../../../utils/hospital'
import { numberWithCommas } from '../../../../utils/number'
import { changeFormatdate, changeFormatFulldate } from '../../../../utils/formatdate'
import moment from 'moment'

const { Text, Title } = Typography

class TalbePeople extends Component {
	state = {
		dataTalbePeople: [],
        columnsPeople: [
            // {
            //     title: 'ลำดับ',
            //     dataIndex: 'book',
            //     width:'8%',
			// 	align:'center',
            //     render: (item, record, index) => <span>{ index+1}</span>
            // },
            {
                title: 'วันที่ดำเนินรายการ',
                dataIndex: 'createdAt',
                width:'20%',
                align:'center',
                render: (item, record, index) => <span>{ item ? changeFormatFulldate(item) : '-'}</span>
            },
			{
                title: 'ผู้ดำเนินรายการ',
                width:'20%',
                dataIndex: 'userAction',
                align:'center',
                render: (item, record, index) => <span>{ item } </span>
            },
            {
                title: 'สถานะ',
                dataIndex: 'status',
                width:'200px',
				align:'center',
                render: (item, record, index) => <span>{ checkStatus(item) }</span>
            },
            {
                title: 'ดำเนินการ',
                dataIndex: 'action',
				align:'center',
                render: (item, record, index) => <span>{ item ? item : '-' }</span>
            },
            {
                title: 'หมายเหตุ',
                dataIndex: 'noteApprove',
                width:'200px',
				align:'center',
                render: (item, record, index) => <>
                    {
                        item ?
                            <span 
                                onClick={()=>{this.showModalNode(item)}} 
                                style={{ cursor:"pointer" }}
                                className="btn-show-fileuploads"
                            > 
                                อ่านหมายเหตุ
                            </span>
                        : '-'
                    }
                   
                </>
            },
        ],
        loadingColumnsPeople:true
	}

    showModalNode = (item) => {
        this.setState({
            showModalNote: true,
            noteModal:item
        });
    };

    async componentDidUpdate(prevProps, prevState, snapshot){
		const { dataTalbePeople } = this.props
            if(prevProps.dataTalbePeople.length !== dataTalbePeople.length){
                await this.setState({
                    dataTalbePeople,
                })

                setTimeout( async() => {
                    await this.setState({
                        loadingColumnsPeople: false
                    })
                }, 5000);
            }
	}


	async componentDidMount() {
		const { dataTalbePeople } = this.props

        if(dataTalbePeople.length !== 0){
            await this.setState({
                dataTalbePeople: false
            })
            setTimeout( async() => {
                await this.setState({
                    loadingColumnsPeople: false
                })
            }, 5000);
           
        }else{
            setTimeout( async() => {
                await this.setState({
                    loadingColumnsPeople: false
                })
            }, 5000);
        }
       
	}

	render() {
		const { showModalNote, titleModal, columnsPeople, dataTalbePeople, loadingColumnsPeople, noteModal } = this.state

        return (
			<>
				<Modal
                    visible={showModalNote}
                    title={"หมายเหตุ"}
                    // onOk={this.handleOk}
                    onCancel={ async()=>{
                        await this.setState({
                            showModalNote:false
                        })
                    }}
                    footer={[]}
                >
                    <div  dangerouslySetInnerHTML={{ __html: noteModal }} />
                </Modal>

                <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white" >
                    <Col xs={24} md={24} className="pt-2 mb-4">
                        <strong className="color-red">
                            ประวัติการดำเนินการ
                        </strong>
                        <Table
                            columns={columnsPeople}
                            dataSource={dataTalbePeople}
                            loading={loadingColumnsPeople}
                            pagination={false}
                            className="mt-4"
                            bordered
                            rowCount={dataTalbePeople.length}
                        />
                    </Col>
                </Row>
			</>
		)
	}
}

TalbePeople.defaultProps = {
	autoFocus: false
}

TalbePeople.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedTalbePeople = Form.create()(TalbePeople)

export default withApollo(WrappedTalbePeople)